export default "__VITE_ASSET__botO3ye2__"